/* Read-only, opt-in navigation. No autoplay, review API calls or global storefront overrides. */
(() => {
  const name = 'joffz-testimonials-v69';
  if (!window.customElements || customElements.get(name)) return;
  class JoffzTestimonials extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-jzh-slide]')];
      if (!this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = 0;
      this.previous = this.querySelector('[data-jzh-prev]');
      this.next = this.querySelector('[data-jzh-next]');
      this.progress = this.querySelector('[data-jzh-progress]');
      this.counter = this.querySelector('[data-jzh-counter]');
      this.details = this.querySelector('[data-jzh-more]');
      this.summary = this.details?.querySelector('summary');
      this.moreBody = this.querySelector('[data-jzh-more-body]');
      this.previous?.addEventListener('click', () => this.show(this.index - 1), options);
      this.next?.addEventListener('click', () => this.show(this.index + 1), options);
      const slider = this.querySelector('.jzh69-slider');
      slider?.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.show(0);
        else if (event.key === 'End') this.show(this.slides.length - 1);
        else this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      const controls = this.querySelector('[data-jzh-controls]');
      if (controls) controls.hidden = this.slides.length < 2;
      if (this.previous) this.previous.disabled = this.slides.length < 2;
      if (this.next) this.next.disabled = this.slides.length < 2;
      this.show(0);
      this.setupGallery(options);
      if (this.moreBody && this.summary && typeof HTMLDialogElement !== 'undefined' && HTMLDialogElement.prototype.showModal) {
        this.summary.addEventListener('click', (event) => {
          event.preventDefault();
          this.openMore();
        }, options);
      } else {
        this.details?.addEventListener('toggle', () => {
          if (this.details.open) this.loadPhotos();
        }, options);
      }
    }
    setupGallery(options) {
      this.imageTrack = this.querySelector('[data-jzh-image-track]');
      this.scenes = [...this.querySelectorAll('[data-jzh-scene]')];
      if (!this.imageTrack || !this.scenes.length) return;
      this.imageIndex = 0;
      this.imageDots = [...this.querySelectorAll('[data-jzh-image-dot]')];
      const controls = this.querySelector('[data-jzh-image-controls]');
      if (controls) controls.hidden = this.scenes.length < 2;
      const previous = this.querySelector('[data-jzh-image-prev]');
      const next = this.querySelector('[data-jzh-image-next]');
      if (previous) previous.disabled = this.scenes.length < 2;
      if (next) next.disabled = this.scenes.length < 2;
      previous?.addEventListener('click', () => this.goImage(this.imageIndex - 1), options);
      next?.addEventListener('click', () => this.goImage(this.imageIndex + 1), options);
      this.imageDots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goImage(index), options);
      });
      this.imageTrack.addEventListener('keydown', (event) => {
        if (event.target !== this.imageTrack || event.altKey || event.ctrlKey || event.metaKey) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        this.goImage(event.key === 'Home' ? 0 : event.key === 'End' ? this.scenes.length - 1 : this.imageIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.imageTrack.addEventListener('scroll', () => {
        cancelAnimationFrame(this.galleryFrame);
        this.galleryFrame = requestAnimationFrame(() => {
          if (!this.imageTrack?.clientWidth) return;
          const index = Math.round(this.imageTrack.scrollLeft / this.imageTrack.clientWidth);
          this.setImageState(index);
        });
      }, { ...options, passive: true });
      if ('ResizeObserver' in window) {
        this.galleryObserver = new ResizeObserver(() => {
          if (!this.imageTrack?.clientWidth) return;
          this.imageTrack.scrollTo({ left: this.imageIndex * this.imageTrack.clientWidth, behavior: 'instant' });
        });
        this.galleryObserver.observe(this.imageTrack);
      }
      this.imageTrack.scrollTo({ left: 0, behavior: 'instant' });
      this.setImageState(0);
    }
    setImageState(index) {
      this.imageIndex = Math.max(0, Math.min(index, this.scenes.length - 1));
      this.imageDots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.imageIndex)));
    }
    goImage(index) {
      if (!this.imageTrack || !this.scenes.length) return;
      const target = (index + this.scenes.length) % this.scenes.length;
      this.setImageState(target);
      const reduce = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      this.imageTrack.scrollTo({ left: target * this.imageTrack.clientWidth, behavior: reduce ? 'instant' : 'smooth' });
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      if (this.counter) this.counter.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (this.progress) this.progress.style.transform = `scaleX(${(this.index + 1) / this.slides.length})`;
    }
    loadPhotos() {
      this.moreBody?.querySelectorAll('img[data-jzh-src]').forEach((image) => {
        if (!image.hasAttribute('src')) image.src = image.dataset.jzhSrc;
        image.hidden = false;
      });
    }
    openMore() {
      if (!this.dialog) {
        this.dialog = document.createElement('dialog');
        this.dialog.className = 'jzh69-modal';
        const title = this.moreBody.querySelector('h3');
        if (title?.id) this.dialog.setAttribute('aria-labelledby', title.id);
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'jzh69-close';
        close.textContent = '×';
        close.setAttribute('aria-label', this.dataset.closeLabel || 'Close');
        const options = { signal: this.controller.signal };
        close.addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => {
          if (!this.dialog?.open) this.restoreMore();
        }, options);
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.appendChild(close);
        document.body.appendChild(this.dialog);
      }
      this.dialog.appendChild(this.moreBody);
      try {
        this.dialog.showModal();
        this.loadPhotos();
        this.dialog.querySelector('button')?.focus({ preventScroll: true });
      } catch (error) {
        this.restoreMore(false);
        this.details.open = true;
        this.loadPhotos();
      }
    }
    restoreMore(focus = true) {
      if (this.moreBody && this.details) {
        this.details.appendChild(this.moreBody);
        this.details.open = false;
      }
      if (focus && this.isConnected) this.summary?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.galleryObserver?.disconnect();
      this.galleryObserver = null;
      cancelAnimationFrame(this.galleryFrame);
      this.controller?.abort();
      this.controller = null;
      this.restoreMore(false);
      if (this.dialog?.open) this.dialog.close();
      this.dialog?.remove();
      this.dialog = null;
    }
  }
  customElements.define(name, JoffzTestimonials);
})();
